import { useNuxtApp, useRuntimeConfig } from "#imports";
import { NUXT_STATE_KEY } from "../constants.js";
export function useI18nLocale() {
  const nuxtApp = useNuxtApp();
  const { i18nLocale } = useRuntimeConfig().public;
  const nuxtLocale = nuxtApp.payload.state[NUXT_STATE_KEY]?.locale;
  return nuxtLocale || i18nLocale.fallbackLocale;
}
